// extracted by mini-css-extract-plugin
module.exports = {"work__card":"WorkCard_work__card__25Ttl","card__cover":"WorkCard_card__cover__1aJHe","card__title":"WorkCard_card__title__3xQQP"};